import { statValues } from "../profiles";
import type { WaterView } from "../view";

export function StatStrip({ view }: { view: WaterView }) {
  return (
    <div className="stat-strip reveal">
      {statValues(view).map((s) => (
        <div className="chip" key={s.label}>
          <dt>{s.label}</dt>
          <div className="cv">
            {s.value}
            <div className="cu">{s.unit}</div>
          </div>
          <span className={`cpill ${s.level}`}>{s.pill}</span>
        </div>
      ))}
    </div>
  );
}
